

  export const SlideSchema = () => ({
    title: "Element",
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['image','alt', 'full', 'title2', 'title', 'description', 'button', 'button_text', 'button_link'],
      },
    ],
  
    properties: {  
      image: {
        title: 'Image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        return: 'single',
      },
      alt: {
        title: 'Image Alt Text',
        type: 'string',
      },
      full: {
        title: "volle Breite",
        type: 'boolean',
      },
      title: {
        title: "Überschrift",
      },
      title2: {
        title: "Überschrift Zusatz",
      },
      description: {
        title: "Beschreibung",
        widget: 'textarea',
      },
      button: {
        title: "show Button",
        type: 'boolean',
      },
      button_text: {
        title: "Button Text",
      },
      button_link: {
        title: "Button Link",
      },
    },
    required: [],
  });
  
export const SliderSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'content',
      title: "Sonsor hinzu",
      fields: ['autoplayEnabled', 'slides'],
    },
  ],

  properties: {
    slides: {
      title: "Elements",
      schema: SlideSchema(intl),
      widget: 'object_list',
    },
    autoplayEnabled: {
      title: "Autoplay",
      default: false,
      type: 'boolean',
    },
    autoplayDelay: {
      title: "Autoplay Delay",
      type: 'integer',
      default: 4,
    },
    slideSpeed: {
      title: "Slider Speed",
      default: false,
      type: 'integer',
      default: 1000,
    },
  },
  required: [],
});
